module.exports = __webpack_public_path__ + "img/hy.25206b9e.svg";